import { render, staticRenderFns } from "./SelfAssessment.vue?vue&type=template&id=4e835de2&"
import script from "./SelfAssessment.vue?vue&type=script&lang=js&"
export * from "./SelfAssessment.vue?vue&type=script&lang=js&"
import style0 from "./SelfAssessment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports